// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsSidebar-cls1__c1940c6412ca28efce93","cls2":"ToolsSidebar-cls2__ba88eb18ba4ed7736f4a ToolsSidebar-cls1__c1940c6412ca28efce93"};